module.exports = __webpack_public_path__ + "media/images/icons/illustration/bieden-f2af57c02c160befd42e102dfea192c8.svg";